import { isGlassEffectAPIAvailable, isLiquidGlassAvailable } from 'expo-glass-effect';
import { Platform } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Reports whether a Liquid Glass surface can be rendered on this device.
 *
 * Glass is only available on iOS 26 and later.
 *
 * NOTE: Accessibility settings such as "Reduce Transparency" are handled by the system,
 * which renders the glass in its reduced form, so no extra check is needed here.
 */
export const useLiquidGlassAvailability = () => {
  return checkIfLiquidGlassSupported();
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function checkIfLiquidGlassSupported() {
  if (Platform.OS !== 'ios') return false;

  if (!isGlassEffectAPIAvailable()) return false;

  return isLiquidGlassAvailable();
}
